import { useEffect, useState } from 'react'

import { getRequestProfileChatsCounters } from '../../../../../api'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileTabChatsCounters(requestId) {
  const { outboundUuid } = useRequestProfileContext()

  const [loaded, setLoaded] = useState(EMPTY_OBJECT)

  async function handleLoadCounters() {
    return getRequestProfileChatsCounters({ id: requestId, outboundUuid })
      .then(response => {
        setLoaded({ counters: response?.data || EMPTY_OBJECT, requestId })

        return response
      })
      .catch(() => {
        setLoaded({ counters: EMPTY_OBJECT, requestId })

        return null
      })
  }

  useEffect(() => {
    if (requestId) {
      handleLoadCounters()
    }
  }, [requestId])

  // An error still tags the request, so readiness flips true on failure too.
  const isCountersReady = requestId != null && loaded.requestId === requestId

  return {
    counters: isCountersReady ? loaded.counters : EMPTY_OBJECT,
    handleLoadCounters,
    isCountersReady,
  }
}
